module.exports = __webpack_public_path__ + "static/media/event-screenshot-beyonce.cf349738.png";